/* The build sheet's chooser.

   Two things were wrong with a native select here.

   It renders one run of text, so "Archway connector · $90.77" and "L-shaped
   base · $48.54" put their figures at a different indent on every line and
   the price column zig-zagged down the list. The figures now sit in a column
   of their own, in the mono face, with tabular figures, so they line up with
   each other and with the totals underneath.

   And it holds one answer. "Functional Accessories" is thirteen different
   connectors and bases; a stand that needs five of them could be given one,
   and there was no way to ask for two of anything. Every companion row is
   now multiple choice with a count against each line, and what is chosen
   stays listed under the control so it can be read without opening it.

   The build row is still single choice, because a stand is built one way.

   The native select stays in the DOM, hidden from sight and from assistive
   technology. On a single row it is still the thing that holds the value.
   On a companion row the answers ride in a hidden field beside it as JSON
   and the select is kept pointed at the first of them, so a page without
   scripting still submits something sensible. mp-buy.js reads the field if
   it is there and the select if it is not. */
(function () {
  "use strict";

  var MAXQ = 99;

  /* A row with this many answers or fewer is left open on the page. The
     control was hiding every answer behind one line of text: a buyer could
     not see that there was a second build, what the companions were, or
     what any of them cost, without opening two or three lists one at a
     time. A row longer than this stays a list, because thirteen connectors
     printed in full would bury the rest of the sheet — but it says how many
     it holds and what they start at, so at least the page admits they exist. */
  var OPEN_MAX = 5;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function money(cents) {
    /* Every price in the catalogue is a whole dollar, so a trailing ".00" is
       two characters of noise on every figure on the page. Cents are still
       printed if a figure ever has any. */
    var n = Math.round(cents) / 100;
    var s = n % 1 === 0 ? String(n) : n.toFixed(2);
    return "$" + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  /* The option's text as the catalogue writes it: "Add one · $90.77", or on
     the build row "3 m × 2.25 m · $1,862.18". Everything from the middle dot
     onwards is the price and belongs in the other column. */
  function split(opt) {
    var raw = (opt.textContent || "").replace(/\s+/g, " ").trim();
    var cut = raw.indexOf("·");
    var name = cut > 0 ? raw.slice(0, cut).trim() : raw;
    var tail = cut > 0 ? raw.slice(cut + 1).trim() : "";
    var cents = parseInt(opt.getAttribute("data-cents") || opt.getAttribute("data-price"), 10);
    var price = isNaN(cents) ? tail : (cents > 0 ? money(cents) : "");
    /* "(made to order)" and anything else the catalogue appends is a note
       about the row, not part of its name or its price. */
    var note = "";
    var m = name.match(/\(([^)]+)\)\s*$/);
    if (m) { note = m[1]; name = name.slice(0, m.index).trim(); }
    var m2 = tail.match(/\(([^)]+)\)\s*$/);
    if (m2 && !note) note = m2[1];
    return {
      name: name || raw,
      price: price,
      note: note,
      cents: isNaN(cents) ? 0 : cents,
      full: (opt.getAttribute("data-name") || "").trim() || (name || raw)
    };
  }

  var TICK = '<svg class="mpk-tick" viewBox="0 0 16 14" fill="none" aria-hidden="true">'
           + '<path d="M1.6 7.4 5.9 11.7 14.3 2.6" stroke="currentColor" stroke-width="2"'
           + ' stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV = '<svg class="mpk-chev" viewBox="0 0 12 8" fill="none" aria-hidden="true">'
           + '<path d="M1 1.5 6 6.5 11 1.5" stroke="currentColor" stroke-width="1.7"'
           + ' stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var openPanel = null;   /* only ever one list on screen */

  /* ---------------------------------------------------------- the marks --
     A dropdown told a buyer the name of a thing and nothing about it. These
     are the smallest drawings that separate the answers people actually choose
     between here — a whole stand from the printed skin for one, a counter from
     a light box, a frame with nothing on it — so the row can be read before it
     is read. Stroke only, in the current colour, so a chosen row's mark turns
     with its text and nothing has to be redrawn for a dark day.

     An answer that is not one of these carries no mark rather than a wrong
     one, and the column stays where it is so the names still line up. */
  function svg(d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"'
         + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'
         + d + '</svg>';
  }
  var MARK = {
    complete: svg('<rect x="3" y="4.5" width="18" height="11" rx="1.2"/>'
                + '<rect x="8" y="16.5" width="8" height="3.6" rx=".8"/>'),
    graphic:  svg('<rect x="4" y="4" width="16" height="16" rx="1.6"/>'
                + '<path d="M4.5 15.5l4.2-4.2 3.3 3.3 2.6-2.6 4.9 4.9"/>'),
    frame:    svg('<path d="M4 8.5V4h4.5M15.5 4H20v4.5M20 15.5V20h-4.5M8.5 20H4v-4.5"/>'),
    counter:  svg('<path d="M5 8.5h14l1.2 11H3.8z"/><path d="M4.6 12.5h14.8"/>'),
    light:    svg('<rect x="6" y="6" width="12" height="12" rx="1.4"/>'
                + '<path d="M12 2.4v1.9M12 19.7v1.9M2.4 12h1.9M19.7 12h1.9"/>'),
    arch:     svg('<path d="M3.6 20.2v-8.4a8.4 8.4 0 0 1 16.8 0v8.4"/>'
                + '<path d="M8.4 20.2v-8.4a3.6 3.6 0 0 1 7.2 0v8.4"/>'),
    tower:    svg('<rect x="8.4" y="3" width="7.2" height="18" rx="1.1"/><path d="M8.4 8.6h7.2"/>'),
    kase:     svg('<rect x="3" y="7" width="18" height="12" rx="1.5"/>'
                + '<path d="M9 7V4.8h6V7"/><path d="M3 12.4h18"/>'),
    size:     svg('<rect x="3.4" y="6.8" width="17.2" height="10.4" rx="1"/><path d="M8.6 6.8v10.4"/>')
  };

  function mark(name) {
    var s = String(name || "").toLowerCase();
    if (!s) return "";
    /* "Frames, No Graphic" ends in the word graphic and is the opposite of
       it, so the frame is asked about first. */
    if (/no graphic|\bframe\b|\bframes\b/.test(s))        return MARK.frame;
    if (/graphic only|^graphic\b|\bgraphic$/.test(s))      return MARK.graphic;
    if (/light ?box|backlit|\bled\b|\blit\b/.test(s))     return MARK.light;
    if (/\barch/.test(s))                                   return MARK.arch;
    if (/counter|podium|\bdesk\b|table/.test(s))            return MARK.counter;
    if (/tower|totem|banner stand/.test(s))                  return MARK.tower;
    if (/\bcase\b|\bbag\b|trolley|wheel/.test(s))         return MARK.kase;
    if (/complete|\bfull\b|\bwhole\b|\bkit\b|\bstand\b|booth|wall|backdrop/.test(s))
                                                             return MARK.complete;
    if (/\d\s*(?:ft|m|in|")?\s*[x\u00d7]\s*\d/.test(s)) return MARK.size;
    return "";
  }

  function frame(sel) {
    var wrap = document.createElement("div");
    wrap.className = "mpk";
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add("mpk-native");
    sel.setAttribute("tabindex", "-1");
    sel.setAttribute("aria-hidden", "true");

    var label = sel.getAttribute("aria-label") || "";
    if (!label) {
      var lb = sel.id ? document.querySelector('label[for="' + sel.id + '"]') : null;
      label = lb ? lb.textContent.trim() : "Choose";
    }

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "mpk-btn";
    btn.setAttribute("aria-haspopup", "true");
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-label", label);
    btn.innerHTML = '<span class="mpk-cur"></span><span class="mpk-cash"></span>' + CHEV;
    return { wrap: wrap, btn: btn, label: label };
  }

  function placeAndOpen(wrap, btn) {
    if (openPanel) openPanel();
    var box = wrap.getBoundingClientRect();
    wrap.dataset.up = (window.innerHeight - box.bottom < 280 && box.top > 320) ? "1" : "0";
    wrap.dataset.open = "1";
    btn.setAttribute("aria-expanded", "true");
  }

  /* ------------------------------------------------- one answer only --- */
  function single(sel, inline) {
    var f = frame(sel), wrap = f.wrap, btn = f.btn;
    if (inline) wrap.dataset.inline = "1";

    var pop = document.createElement("div");
    pop.className = "mpk-pop";
    pop.setAttribute("role", "listbox");
    pop.setAttribute("aria-label", f.label);

    var rows = [];
    Array.prototype.forEach.call(sel.options, function (o, i) {
      var d = split(o);
      var row = document.createElement("div");
      row.className = "mpk-opt" + (o.value ? "" : " is-null");
      row.setAttribute("role", "option");
      row.setAttribute("aria-selected", i === sel.selectedIndex ? "true" : "false");
      row.innerHTML = TICK + '<span class="mpk-ic">' + (mark(d.name) || mark(f.label)) + '</span>'
                    + '<span class="mpk-nm"></span>'
                    + '<span class="mpk-pr' + (d.price ? "" : " free") + '"></span>';
      var nm = row.querySelector(".mpk-nm");
      nm.textContent = d.name;
      if (d.note) {
        var sub = document.createElement("span");
        sub.className = "mpk-sub";
        sub.textContent = d.note;
        nm.appendChild(sub);
      }
      row.querySelector(".mpk-pr").textContent = d.price || (o.value ? "" : "—");
      row.addEventListener("click", function () { choose(i); });
      row.addEventListener("mousemove", function () { active(i); });
      if (inline) {
        /* Open on the page, the rows are the control, so they have to be
           reachable from the keyboard in their own right. */
        row.tabIndex = 0;
        row.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
            e.preventDefault(); choose(i);
          }
        });
      }
      pop.appendChild(row);
      rows.push({ el: row, d: d });
    });

    if (!inline) wrap.appendChild(btn);
    wrap.appendChild(pop);
    var at = sel.selectedIndex < 0 ? 0 : sel.selectedIndex;

    function head() {
      var i = sel.selectedIndex < 0 ? 0 : sel.selectedIndex;
      var d = rows[i] ? rows[i].d : { name: "", price: "" };
      btn.querySelector(".mpk-cur").textContent = d.name;
      var cash = btn.querySelector(".mpk-cash");
      cash.textContent = d.price || "—";
      cash.className = "mpk-cash" + (d.price ? "" : " none");
      rows.forEach(function (r, k) {
        r.el.setAttribute("aria-selected", k === i ? "true" : "false");
      });
    }
    function active(i) {
      at = i;
      rows.forEach(function (r, k) {
        if (k === i) r.el.setAttribute("data-active", "1");
        else r.el.removeAttribute("data-active");
      });
    }
    function show() {
      placeAndOpen(wrap, btn);
      active(sel.selectedIndex < 0 ? 0 : sel.selectedIndex);
      var cur = rows[at] && rows[at].el;
      if (cur && cur.scrollIntoView) cur.scrollIntoView({ block: "nearest" });
      openPanel = hide;
    }
    function hide() {
      wrap.dataset.open = "0";
      btn.setAttribute("aria-expanded", "false");
      if (openPanel === hide) openPanel = null;
    }
    function choose(i) {
      sel.selectedIndex = i;
      head();
      if (!inline) { hide(); btn.focus(); }
      sel.dispatchEvent(new Event("change", { bubbles: true }));
    }

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (wrap.dataset.open === "1") hide(); else show();
    });
    btn.addEventListener("keydown", function (e) {
      var k = e.key;
      if (k === "ArrowDown" || k === "ArrowUp" || k === "Enter" || k === " " || k === "Spacebar") {
        e.preventDefault();
        if (wrap.dataset.open !== "1") { show(); return; }
        if (k === "Enter" || k === " " || k === "Spacebar") { choose(at); return; }
        var nx = at + (k === "ArrowDown" ? 1 : -1);
        if (nx < 0) nx = 0;
        if (nx > rows.length - 1) nx = rows.length - 1;
        active(nx);
        if (rows[nx].el.scrollIntoView) rows[nx].el.scrollIntoView({ block: "nearest" });
      } else if (k === "Escape") { hide(); }
      else if ((k === "Home" || k === "End") && wrap.dataset.open === "1") {
        e.preventDefault(); active(k === "Home" ? 0 : rows.length - 1);
      }
    });

    sel.addEventListener("change", head);
    head();
  }

  /* --------------------------------------------- as many as you like --- */
  function multi(sel, inline) {
    var f = frame(sel), wrap = f.wrap, btn = f.btn;
    wrap.classList.add("mpk-many");
    if (inline) wrap.dataset.inline = "1";

    /* What mp-buy.js reads. Deliberately nameless, so the product form does
       not try to submit it: the cart payload is built by hand. */
    var carrier = document.createElement("input");
    carrier.type = "hidden";
    carrier.setAttribute("data-addon-cart", "");
    carrier.value = "[]";

    var chosenList = document.createElement("ul");
    chosenList.className = "mpk-chosen";

    var pop = document.createElement("div");
    pop.className = "mpk-pop mpk-pop-many";
    pop.setAttribute("role", "group");
    pop.setAttribute("aria-label", f.label);

    var items = [];
    Array.prototype.forEach.call(sel.options, function (o) {
      if (!o.value) return;                       /* "Not needed" is the empty state */
      var d = split(o);
      items.push({ id: o.value, d: d, q: 0, el: null, out: null });
    });

    var clear = document.createElement("button");
    clear.type = "button";
    clear.className = "mpk-opt is-null mpk-clear";
    clear.innerHTML = TICK + '<span class="mpk-ic"></span><span class="mpk-nm">Not needed</span>'
                    + '<span class="mpk-pr free">—</span>';
    clear.addEventListener("click", function () {
      items.forEach(function (it) { it.q = 0; });
      paint();
    });
    pop.appendChild(clear);

    items.forEach(function (it) {
      var row = document.createElement("div");
      row.className = "mpk-opt mpk-opt-q";
      row.innerHTML = TICK
        + '<span class="mpk-ic">' + (mark(it.d.name) || mark(f.label)) + '</span>'
        + '<span class="mpk-nm"></span>'
        + '<span class="mpk-pr"></span>'
        + '<span class="mpk-step">'
        +   '<button type="button" class="mpk-less" tabindex="-1">−</button>'
        +   '<output class="mpk-q">0</output>'
        +   '<button type="button" class="mpk-more" tabindex="-1">+</button>'
        + '</span>';
      var nm = row.querySelector(".mpk-nm");
      nm.textContent = it.d.name;
      if (it.d.note) {
        var sub = document.createElement("span");
        sub.className = "mpk-sub";
        sub.textContent = it.d.note;
        nm.appendChild(sub);
      }
      row.querySelector(".mpk-pr").textContent = it.d.price || "";
      var less = row.querySelector(".mpk-less");
      var more = row.querySelector(".mpk-more");
      less.setAttribute("aria-label", "One fewer " + it.d.name);
      more.setAttribute("aria-label", "One more " + it.d.name);
      less.addEventListener("click", function (e) { e.stopPropagation(); step(it, -1); });
      more.addEventListener("click", function (e) { e.stopPropagation(); step(it, 1); });
      /* Anywhere else on the row is the ordinary yes-or-no. */
      row.addEventListener("click", function () { it.q = it.q > 0 ? 0 : 1; paint(); });
      if (inline) {
        row.tabIndex = 0;
        row.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
            e.preventDefault(); it.q = it.q > 0 ? 0 : 1; paint();
          }
        });
        less.tabIndex = 0;
        more.tabIndex = 0;
      }
      it.el = row;
      it.out = row.querySelector(".mpk-q");
      pop.appendChild(row);
    });

    var foot = document.createElement("div");
    foot.className = "mpk-foot";
    foot.innerHTML = '<span class="mpk-fsum"></span>'
                   + '<button type="button" class="mpk-done">Done</button>';
    foot.querySelector(".mpk-done").addEventListener("click", function () { hide(); btn.focus(); });
    pop.appendChild(foot);

    if (!inline) wrap.appendChild(btn);
    wrap.appendChild(carrier);
    wrap.appendChild(chosenList);

    /* A row too long to print in full still has to admit what it holds. Shut,
       it used to read "Not needed —", which says nothing about the thirteen
       things behind it or what the cheapest of them costs. */
    if (!inline && items.length) {
      var floor = items.reduce(function (a, it) {
        return (a === 0 || (it.d.cents > 0 && it.d.cents < a)) ? it.d.cents : a;
      }, 0);
      var hint = document.createElement("p");
      hint.className = "mpk-hint";
      hint.textContent = items.length + " to choose from"
                       + (floor > 0 ? ", from " + money(floor) : "");
      wrap.appendChild(hint);
    }

    wrap.appendChild(pop);
    if (inline) clear.tabIndex = 0;

    function step(it, by) {
      it.q = Math.min(MAXQ, Math.max(0, it.q + by));
      paint();
    }

    function taken() { return items.filter(function (it) { return it.q > 0; }); }

    function paint() {
      var on = taken();
      var cents = 0, count = 0;
      on.forEach(function (it) { cents += it.d.cents * it.q; count += it.q; });

      items.forEach(function (it) {
        it.out.value = String(it.q);
        it.out.textContent = String(it.q);
        it.el.setAttribute("aria-selected", it.q > 0 ? "true" : "false");
        it.el.dataset.on = it.q > 0 ? "1" : "0";
        it.el.querySelector(".mpk-less").disabled = it.q === 0;
      });
      clear.setAttribute("aria-selected", on.length ? "false" : "true");

      /* The closed control. */
      var cur = btn.querySelector(".mpk-cur");
      var cash = btn.querySelector(".mpk-cash");
      if (!on.length) {
        cur.textContent = "Not needed";
        cash.textContent = "—";
        cash.className = "mpk-cash none";
      } else if (on.length === 1 && on[0].q === 1) {
        cur.textContent = on[0].d.name;
        cash.textContent = money(cents);
        cash.className = "mpk-cash";
      } else {
        cur.textContent = count + (count === 1 ? " item" : " items")
                        + (on.length > 1 ? " · " + on.length + " lines" : "");
        cash.textContent = money(cents);
        cash.className = "mpk-cash";
      }
      foot.querySelector(".mpk-fsum").textContent = on.length
        ? (count + (count === 1 ? " item" : " items") + " · " + money(cents))
        : "Nothing chosen yet";

      /* The receipt under the control, so it reads without opening. */
      chosenList.innerHTML = "";
      on.forEach(function (it) {
        var li = document.createElement("li");
        li.innerHTML = '<span class="nm"></span><i class="q"></i><b class="pr"></b>'
                     + '<button type="button" class="x" aria-label="Remove">&times;</button>';
        li.querySelector(".nm").textContent = it.d.name;
        li.querySelector(".q").textContent = it.q > 1 ? ("× " + it.q) : "";
        li.querySelector(".pr").textContent = money(it.d.cents * it.q);
        li.querySelector(".x").addEventListener("click", function () { it.q = 0; paint(); });
        chosenList.appendChild(li);
      });
      wrap.dataset.has = on.length ? "1" : "0";

      /* n is the full catalogue name, which is what the studio needs on the
         order; s is the short one, which is what belongs in a column of
         figures on the page. */
      carrier.value = JSON.stringify(on.map(function (it) {
        return { id: it.id, q: it.q, n: it.d.full, s: it.d.name, c: it.d.cents };
      }));

      /* Keep the select pointing somewhere sane, then tell mp-buy.js. */
      sel.value = on.length ? on[0].id : "";
      sel.dispatchEvent(new Event("change", { bubbles: true }));
    }

    function show() { placeAndOpen(wrap, btn); openPanel = hide; }
    function hide() {
      wrap.dataset.open = "0";
      btn.setAttribute("aria-expanded", "false");
      if (openPanel === hide) openPanel = null;
    }

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (wrap.dataset.open === "1") hide(); else show();
    });
    btn.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar" || e.key === "ArrowDown") {
        e.preventDefault(); show();
        var first = pop.querySelector(".mpk-more");
        if (first) first.focus();
      } else if (e.key === "Escape") { hide(); }
    });

    /* A line reopened from the cart comes back with its counts. */
    var want = window.__mpWantAddons;
    if (want) {
      items.forEach(function (it) { if (want[it.id]) it.q = want[it.id]; });
    } else if (sel.value) {
      items.forEach(function (it) { if (it.id === sel.value) it.q = 1; });
    }
    paint();
  }

  function closeAll(e) {
    if (!openPanel) return;
    if (e && e.target && e.target.closest && e.target.closest(".mpk")) return;
    openPanel();
  }

  function boot() {
    var root = document.querySelector("[data-product-root]") || document;
    $$(".mpb-sel", root).forEach(function (sel) {
      if (!sel || sel.dataset.mpk) return;
      sel.dataset.mpk = "1";
      if (sel.hasAttribute("data-addon")) {
        /* "Not needed" is the empty state, not one of the answers. */
        var real = 0;
        Array.prototype.forEach.call(sel.options, function (o) { if (o.value) real++; });
        multi(sel, real > 0 && real <= OPEN_MAX);
      } else {
        single(sel, sel.options.length <= OPEN_MAX);
      }
    });
  }

  document.addEventListener("click", closeAll, true);
  document.addEventListener("keydown", function (e) {
    if ((e.key === "Escape" || e.keyCode === 27) && openPanel) openPanel();
  });
  window.addEventListener("resize", function () { if (openPanel) openPanel(); });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
